/* istanbul ignore file */
export * from './FilterDetails';
